module.exports = __webpack_public_path__ + "img/6.c2106a65.jpeg";